export const homeAbout = [
  {
    id: 1,
    icon: "fa-solid fa-laptop-code",
    title: "Online Courses",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    id: 2,
    icon: "fa-solid fa-certificate",
    title: "Earn A Certificates",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    id: 3,
    icon: "fa-solid fa-chalkboard-user",
    title: "Learn with Expert",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
];
export const awrapper = [
  {
    icon: "fa-solid fa-graduation-cap",
    data: "3,000+",
    title: "SUCCESS STORIES",
  },
  {
    icon: "fa-solid fa-users",
    data: "320",
    title: "TRUSTED TUTORS",
  },
  {
    icon: "fa-solid fa-calendar-days",
    data: "1,000+",
    title: "SCHEDULES",
  },
  {
    icon: "fa-solid fa-book",
    data: "587",
    title: "COURSES",
  },
];
export const coursesCard = [
  {
    id: 1,
    icon: "fa-brands fa-react",
    coursesName: "React JS",
    courTeacher: [
      {
        dcover: "./images/stitch/courses-instructor-1.jpg",
        name: "by Sai",
        totalTime: "50 lectures (190 hrs)",
      },
    ],
    priceAll: "₹8,000 All Course",
    pricePer: "₹1,200 per month",
  },
  {
    id: 2,
    icon: "fa-brands fa-docker",
    coursesName: "DevOps",
    courTeacher: [
      {
        dcover: "./images/stitch/courses-instructor-2.jpg",
        name: "by Pooja",
        totalTime: "30 lectures (125 hrs)",
      },
    ],
    priceAll: "₹16,000 All Course",
    pricePer: "₹2,000 per month",
  },
  {
    id: 3,
    icon: "fa-brands fa-html5",
    coursesName: "HTML, CSS",
    courTeacher: [
      {
        dcover: "./images/stitch/courses-instructor-3.jpg",
        name: "by Sai",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "₹4,000 All Course",
    pricePer: "₹400 per month",
  },
  {
    id: 4,
    icon: "fa-brands fa-node-js",
    coursesName: "Node Js",
    courTeacher: [
      {
        dcover: null,
        name: "by Nandhu",
        totalTime: "20 lectures (20 hrs)",
      },
    ],
    priceAll: "₹2,500 All Course",
    pricePer: "₹250 per month",
  },
  {
    id: 5,
    icon: "fa-brands fa-js",
    coursesName: "JavaScript",
    courTeacher: [
      {
        dcover: null,
        name: "by Sai",
        totalTime: "100 lectures (150 hrs)",
      },
    ],
    priceAll: "₹25,000 All Course",
    pricePer: "₹2,500 per month",
  },
  {
    id: 6,
    icon: "fa-solid fa-robot",
    coursesName: "AI  ",
    courTeacher: [
      {
        dcover: null,
        name: "by Veera",
        totalTime: "200 lectures (300 hrs)",
      },
    ],
    priceAll: "₹40,000 All Course",
    pricePer: "₹6,500 per month",
  },
  {
    id: 7,
    icon: "fa-solid fa-chart-line",
    coursesName: "Data Science",
    courTeacher: [
      {
        dcover: null,
        name: "by Ananya Pillai",
        totalTime: "20 lectures (50 hrs)",
      },
    ],
    priceAll: "₹1,600 All Course",
    pricePer: "₹150 per month",
  },
  {
    id: 8,
    icon: "fa-solid fa-database",
    coursesName: "Data Engineering",
    courTeacher: [
      {
        dcover: null,
        name: "by Manoj Tiwari",
        totalTime: "80 lectures (200 hrs)",
      },
    ],
    priceAll: "₹16,000 All Course",
    pricePer: "₹3,200 per month",
  },
  {
    id: 9,
    icon: "fa-solid fa-chart-bar",
    coursesName: "Data Analyst",
    courTeacher: [
      {
        dcover: null,
        name: "by Deepika Nair",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "₹1,600 All Course",
    pricePer: "₹250 per month",
  },
];
export const online = [
  {
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
    courseName: "UI/UX Design Courses",
    course: "25 Courses",
  },
  {
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
    courseName: "Art & Design",
    course: "25 Courses",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "Computer Science",
    course: "10 Courses",
  },
  {
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
    courseName: "History & Archeologic",
    course: "15 Courses",
  },
  {
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
    courseName: "Software Engineering",
    course: "30 Courses",
  },
  {
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
    courseName: "Information Software",
    course: "60 Courses",
  },
  {
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
    courseName: "Health & Fitness",
    course: "10 Courses",
  },
  {
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
    courseName: "Marketing",
    course: "30 Courses",
  },
  {
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
    courseName: "Graphic Design",
    course: "80 Courses",
  },
  {
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
    courseName: "Music",
    course: "120 Courses",
  },
  {
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
    courseName: "Business Administration",
    course: "17 Courses",
  },
  {
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
    courseName: "Web Management",
    course: "17 Courses",
  },
];
export const team = [
  {
    cover: "./images/team/t1.webp",
    name: "Ph.D Adrian Molises",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t2.webp",
    name: "Ph.D Arthur MaGregor",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t3.webp",
    name: "Ph.D Anna Hanzen",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t4.webp",
    name: "Ph.D Brian Wooden",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t5.webp",
    name: "Ph.D Adrian Molises",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t6.webp",
    name: "Ph.D Arthur MaGregor",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t7.webp",
    name: "Ph.D Anna Hanzen",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
  {
    cover: "./images/team/t8.webp",
    name: "Ph.D Brian Wooden",
    work: "DEVELOPER AND LEAD INSTRUCTOR",
  },
];
export const price = [
  {
    name: "BASIC PLAN",
    price: "49K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "BEGINNER PLAN",
    price: "79K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "PREMIUM PLAN",
    price: "109k",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "ULTIMATE PLAN",
    price: "149K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
];
export const faq = [
  {
    title: "How to Enroll This Online Courses?",
    desc: "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "Where It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How to Enroll This Online Courses?",
    desc: "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "Where It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
  {
    title: "How It is hidden by default, until the collapse?",
    desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
  },
];
export const blog = [
  {
    id: 1,
    type: "admin",
    date: "NOV. 18, 2025",
    com: "3 COMMENTS ",
    title: "Build your Dream Front-End Developer",
    // desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b1.webp",
  },
  {
    id: 2,
    type: "admin",
    date: "DEC. 05, 2025",
    com: "5 COMMENTS ",
    title: "Build your Dream Devops Engineer",
    // desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b2.webp",
  },
  {
    id: 3,
    type: "user",
    date: "MAY. 15, 2024",
    com: "10 COMMENTS ",
    title: "Build your Dream Full Stack Developer",
    // desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b3.webp",
  },
  {
    id: 4,
    type: "admin",
    date: "JAN. 02, 2022",
    com: "3 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b4.webp",
  },
  {
    id: 5,
    type: "admin",
    date: "DEC. 14, 2022",
    com: "3 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b5.webp",
  },
  {
    id: 6,
    type: "user",
    date: "JAN. 18, 2021",
    com: "12 COMMENTS ",
    title: "Build your Dream Software & Engineering Career",
    desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b6.webp",
  },
];
export const testimonal = [
  {
    id: 1,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t1.webp",
  },
  {
    id: 2,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t2.webp",
  },
  {
    id: 3,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t3.webp",
  },
];
